import { removeFromLocalStorage } from "./localStorageUtils";
import { removeFromSessionStorage } from "./sessionStorageUtils";
import { LocalStorageKey, SessionStorageKey } from "./storageKeys";

export const clearStorageOnError = () => {
  [
    LocalStorageKey.TABLE_DATA,
    LocalStorageKey.SCAN_TO_ORDER_INFO,
    LocalStorageKey.BOOKED_SERVICE_CART,
  ].forEach((key: LocalStorageKey) => removeFromLocalStorage(key));
  [
    SessionStorageKey.GIFT_CARD_INFO,
    SessionStorageKey.DELIVERY_TRACKING_URL,
    SessionStorageKey.CAN_ACCESS_CONFIRMATION,
    SessionStorageKey.RECEIPT_ID,
  ].forEach((key: SessionStorageKey) => removeFromSessionStorage(key));
};
